// Classes.
import {BooleanLocatorComponent} from './boolean.locator-component';


export class CardinalityLocatorComponent extends BooleanLocatorComponent {

  public constructor(_value: boolean = false) {
    super(_value);
  };

  public toString(): string {
    return this._value ? 'team' : 'individual';
  }

  /**
   * isTeam setter/getter.
   */
  set isTeam(isTeam: boolean) {
    this._value = isTeam;
  }

  get isTeam(): boolean {
    return this._value;
  }
}
